export default "__VITE_ASSET__CkQD2iOq__"